import { render } from "./LottoCreateView.vue?vue&type=template&id=7c4bc862&ts=true"
import script from "./LottoCreateView.vue?vue&type=script&lang=ts"
export * from "./LottoCreateView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__